import { z } from "zod";
import { COLLAR_COLORS } from "./constants.js";
export const emailSchema = z.string().email().toLowerCase().trim();
export const passwordSchema = z
    .string()
    .min(10, "Mindestens 10 Zeichen")
    .max(200);
export const phoneE164Schema = z
    .string()
    .regex(/^\+[1-9]\d{6,14}$/, "Internationales Format, z.B. +491701234567");
export const addressSchema = z.object({
    street: z.string().min(1).max(200),
    zip: z.string().min(1).max(20),
    city: z.string().min(1).max(100),
    country: z.string().length(2).default("DE"),
});
export const signupInput = z.object({
    email: emailSchema,
    password: passwordSchema,
    name: z.string().min(1).max(200),
    ...addressSchema.shape,
    phoneE164: phoneE164Schema.optional(),
    acceptTerms: z.literal(true, { errorMap: () => ({ message: "AGB bitte akzeptieren" }) }),
});
export const loginInput = z.object({
    email: emailSchema,
    password: z.string().min(1),
});
export const updateProfileInput = z.object({
    name: z.string().min(1).max(200).optional(),
    street: z.string().min(1).max(200).optional(),
    zip: z.string().min(1).max(20).optional(),
    city: z.string().min(1).max(100).optional(),
    country: z.string().length(2).optional(),
    phoneE164: phoneE164Schema.nullable().optional(),
    findingsEmail: emailSchema.nullable().optional(),
});
export const petSpeciesSchema = z.enum(["dog", "cat", "dragon"]);
export const catInput = z.object({
    name: z.string().min(1).max(60),
    species: petSpeciesSchema.default("cat"),
    motto: z.string().max(80).nullable().optional(),
    steckbrief: z.string().max(1000).nullable().optional(),
    visibleName: z.boolean().default(true),
    visibleMotto: z.boolean().default(true),
    visibleSteckbrief: z.boolean().default(true),
    visiblePhotos: z.boolean().default(true),
    showDistanceToFinder: z.boolean().default(true),
    smsEnabled: z.boolean().default(false),
});
export const findingInput = z.object({
    lat: z.coerce.number().min(-90).max(90).optional(),
    lng: z.coerce.number().min(-180).max(180).optional(),
    accuracyM: z.coerce.number().min(0).max(1_000_000).optional(),
    // Freitext-Fundort, falls GPS nicht klappt — serverseitig geokodiert.
    address: z.string().max(200).optional(),
    message: z.string().max(500).optional(),
    // Optionale Rückrufnummer des Finders (freiwillig) + WhatsApp-Wunsch.
    finderPhone: z.string().trim().max(30).optional(),
    finderWhatsapp: z.coerce.boolean().optional(),
});
/** Ziffern-only Telefonnummer -> wa.me-Deeplink, oder null wenn unbrauchbar. */
export function whatsappLink(phone) {
    if (!phone)
        return null;
    const digits = phone.replace(/[^\d]/g, "");
    return digits.length >= 8 ? `https://wa.me/${digits}` : null;
}
export const collarColorSchema = z.enum(COLLAR_COLORS);
export const orderInput = z.object({
    catId: z.string().min(6).max(8), // 6 = current, 8 = legacy ids pre-shortening
    // "collar" = Sicherheitshalsband, "tag" = Mini-Anhänger fürs vorhandene Halsband.
    productType: z.enum(["collar", "tag"]).default("collar"),
    // Versand: Brief (unversichert) oder Paket (versichert).
    shippingMethod: z.enum(["brief", "paket"]).default("brief"),
    collars: z
        .array(z.object({
        // Farbe nur beim Halsband; der Mini-Anhänger hat eine Standard-Ausführung.
        color: collarColorSchema.optional(),
        showName: z.boolean(),
        // Motto/Slogan wird nicht mehr aufs Halsband gedruckt. Feld bleibt aus
        // Kompatibilitätsgründen (DB-Spalte), defaultet immer auf false.
        showMotto: z.boolean().optional().default(false),
    }))
        .min(1)
        .max(10),
    shippingAddress: addressSchema,
});
export const smsTopupInput = z.object({
    amountCents: z.number().int().positive(),
});
// Public Cat representation (finder page)
export const publicCat = z.object({
    id: z.string(),
    name: z.string().nullable(),
    motto: z.string().nullable(),
    steckbrief: z.string().nullable(),
    photos: z.array(z.object({ url: z.string(), isPrimary: z.boolean() })),
    active: z.boolean(),
});
//# sourceMappingURL=schemas.js.map